/**
 * Array and record lookups typed the way they actually behave.
 *
 * `noUncheckedIndexedAccess` is off in this app, so `arr[i]` and `rec[k]` are
 * typed as always hitting. At runtime neither does — an out-of-range index and a
 * missing key both give `undefined` — and the gap shows up as
 * `no-unnecessary-condition` firing on a guard that is doing real work.
 *
 * These say what the runtime says, so the guards downstream are honest rather
 * than suppressed one by one.
 */

export function at<T>(items: readonly T[], index: number): T | undefined {
  return items[index] as T | undefined;
}

export function get<T>(record: Readonly<Record<string, T>>, key: string): T | undefined {
  return record[key] as T | undefined;
}
